import React from 'react'
import JobDescription from '../../../../Components/JobDescription'

const Marketing = () => {
  return (
   <JobDescription 
  jobTitle="Digital Marketing Analyst"
  location="Chennai"
  department="Marketing"
  jobType="Full-Time"
  experienceLevel="1-3 Years"
  roleDescription="Drive data-driven marketing success at {brandName}! We're seeking a Digital Marketing Analyst who can turn complex data into actionable insights, optimize campaigns, and help scale our digital presence across multiple channels."
  responsibilities={[
    "Analyze digital marketing performance across all channels",
    "Create comprehensive reports and data visualizations",
    "Optimize campaigns for better ROI and conversion rates",
    "Conduct A/B testing and performance experiments",
    "Track and analyze customer journey and behavior patterns",
    "Collaborate with creative and strategy teams on campaigns",
    "Monitor market trends and competitor analysis",
  ]}
  skills={[
    "Google Analytics, Google Ads, Facebook Ads Manager",
    "Excel, SQL, Data visualization tools (Tableau/Power BI)",
    "SEO/SEM, Social media analytics",
    "Statistical analysis and A/B testing",
    "Marketing automation platforms",
  ]}
  requirements={[
    "2-3 years of digital marketing analytics experience",
    "Strong analytical mindset with attention to detail",
    "Proven track record of campaign optimization",
    "Ability to translate data into business insights",
    "Excellent presentation and communication skills",
  ]}
  benefits={[
    "Work with diverse brands and exciting marketing campaigns.",
    "Access to premium marketing tools and training programs.",
    "Creative freedom with data-driven decision making.",
  ]}
   onApply={() => console.log("Applied for Digital Marketing Analyst")}
  applyUrl="/apply/digital-marketing-analyst"
/>
  )
}

export default Marketing